import BaseProxy from './Proxy';

export default class ContractSearchProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/contract', parameters);
  }

  list() {
    return this.submit('get', `${this.endpoint}/list`);
  }

  search() {
    return this.submit('get', `${this.endpoint}/search`);
  }

  searchDescriptions(context) {
    return this.submit('get', `${this.endpoint}/search/descriptions/${context}`);
  }

  searchRechargingTransactions() {
    return this.submit('get', `${this.endpoint}/search/transactions/recharging`);
  }

  change() {
    return this.submit('get', `${this.endpoint}/change`);
  }
}
